import React, { lazy, Suspense } from 'react';
import AppLoader from '../../components/loading';

const lazyLoad = (importer, Loader) => {
  const LazyComp = lazy(importer);
  return (props) => (
    <Suspense fallback={Loader ? <Loader /> : <AppLoader />}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <LazyComp {...props} />
    </Suspense>
  );
};

const Home = lazyLoad(() => import('../home'), AppLoader);
const MyAccount = lazyLoad(() => import('../my-account'), AppLoader);
const SubscriptionDetails = lazyLoad(
  () => import('../subscription-details'),
  AppLoader,
);
const PaymentDetails = lazyLoad(() => import('../payment-details'), AppLoader);
const DueDateCalculator = lazyLoad(
  () => import('../due-date-calculator'),
  AppLoader,
);
const WeekByWeek = lazyLoad(() => import('../week-by-week'), AppLoader);
const ThankYou = lazyLoad(() => import('../checkout/thank-you'), AppLoader);
const UnifiedReceipt = lazyLoad(
  () => import('../checkout-unified/Receipt'),
  AppLoader,
);
const StartMembership = lazyLoad(
  () => import('../checkout-single-page/start-membership'),
  AppLoader,
);
const WelcomeFlow = lazyLoad(
  () => import('../checkout-single-page/welcome-flow'),
  AppLoader,
);
const UnifiedCheckout = lazyLoad(
  () => import('../checkout-unified'),
  AppLoader,
);
const Shop = lazyLoad(() => import('../shop'), AppLoader);
const Faq = lazyLoad(() => import('../faq'), AppLoader);
const About = lazyLoad(() => import('../about'), AppLoader);
const BumpFund = lazyLoad(() => import('../bump-fund'), AppLoader);
const LoyaltyProgram = lazyLoad(() => import('../loyalty-program'), AppLoader);
const Contact = lazyLoad(() => import('../contact'), AppLoader);
const Partnerships = lazyLoad(() => import('../partnerships'), AppLoader);
const SignIn = lazyLoad(() => import('../signin'), AppLoader);
const ForgotPassword = lazyLoad(() => import('../forgot-password'), AppLoader);
const ResetPassword = lazyLoad(() => import('../reset-password'), AppLoader);
const BreastPump = lazyLoad(() => import('../breast-pump'), AppLoader);
const Careers = lazyLoad(() => import('../careers'), AppLoader);
const TermsOfService = lazyLoad(() => import('../terms-of-service'), AppLoader);
const PrivacyPolicy = lazyLoad(() => import('../privacy-policy'), AppLoader);
const SecurityDisclosure = lazyLoad(
  () => import('../security-disclosure'),
  AppLoader,
);
const ElectronicRecordsAndSignatureDisclosure = lazyLoad(
  () => import('../electronic-records-and-signature-disclosure'),
  AppLoader,
);
const CorpGifting = lazyLoad(() => import('../corporate-gifting'), AppLoader);
const Press = lazyLoad(() => import('../press'), AppLoader);
const ErrorPage = lazyLoad(() => import('../error'), AppLoader);
const Page404 = lazyLoad(() => import('../page-404'), AppLoader);
const Page403 = lazyLoad(() => import('../page-403'), AppLoader);
const Product = lazyLoad(() => import('../product'), AppLoader);
const Review = lazyLoad(() => import('../review'), AppLoader);
const SelectSubscription = lazyLoad(
  () => import('../select-subscription'),
  AppLoader,
);
const GiftPage = lazyLoad(() => import('../gift'), AppLoader);
const Checkout = lazyLoad(() => import('../checkout'), AppLoader);
const AdminPortalEntry = lazyLoad(
  () => import('../admin-portal-entry'),
  AppLoader,
);
const ShopRedirect = lazyLoad(() => import('../shop-redirect'), AppLoader);
const BlogRedirect = lazyLoad(() => import('../blogredirect'), AppLoader);
const Blog = lazyLoad(() => import('../blog'), AppLoader);
const BreastPumpBrowse = lazyLoad(
  () => import('../breast-pump/breast-pump-browse'),
  AppLoader,
);
const BreastPumpPostPurchase = lazyLoad(
  () => import('../breast-pump/breast-pump-post-purchase'),
  AppLoader,
);
const BreastPumpThankYou = lazyLoad(
  () => import('../breast-pump/thank-you'),
  AppLoader,
);
const CorporatePortal = lazyLoad(
  () => import('../corporate-portal'),
  AppLoader,
);
const CorporateWSP = lazyLoad(() => import('../corporate-wsp'), AppLoader);
const CorporateVerification = lazyLoad(
  () => import('../corporate-verification'),
  AppLoader,
);
const PrenatalVitamins = lazyLoad(
  () => import('../prenatal-vitamins'),
  AppLoader,
);
const CustomizeSubscription = lazyLoad(
  () => import('../customize-subscription'),
  AppLoader,
);
const CustomizeSubscriptionLandingPage = lazyLoad(
  () => import('../customize-subscription-landing-page'),
  AppLoader,
);
const ViewRegistry = lazyLoad(
  () => import('../registry/view-registry'),
  AppLoader,
);
const FindRegistry = lazyLoad(
  () => import('../registry/find-registry'),
  AppLoader,
);
const ManageRegistry = lazyLoad(
  () => import('../registry/manage-registry'),
  AppLoader,
);
const CreateRegistry = lazyLoad(
  () => import('../registry/create-registry'),
  AppLoader,
);
const Covid19 = lazyLoad(() => import('../covid19'), AppLoader);
const PatientGrievance = lazyLoad(
  () => import('../patient-grievance'),
  AppLoader,
);
const PatientRights = lazyLoad(() => import('../patient-rights'), AppLoader);
const PrivacyNotice = lazyLoad(() => import('../privacy-notice'), AppLoader);
const Warranty = lazyLoad(() => import('../warranty'), AppLoader);
const AssignmentOfBenefits = lazyLoad(
  () => import('../assignment-of-benefits'),
  AppLoader,
);
const MyOrder = lazyLoad(() => import('../my-order'), AppLoader);
const EditPayment = lazyLoad(() => import('../edit-payment'), AppLoader);
const Giveaway = lazyLoad(() => import('../giveaway'), AppLoader);
const ReferAFriend = lazyLoad(() => import('../refer-a-friend'), AppLoader);
const Extensions = lazyLoad(() => import('../extensions'), AppLoader);
const CustomerReviews = lazyLoad(
  () => import('../customer-reviews'),
  AppLoader,
);
const Offers = lazyLoad(() => import('../offers'), AppLoader);
const GiveawayTerms = lazyLoad(() => import('../giveaway-terms'), AppLoader);
const ImageEditor = lazyLoad(() => import('../image-editor'), AppLoader);
const BabyNames = lazyLoad(() => import('../baby-names'), AppLoader);

export {
  Home,
  MyAccount,
  SubscriptionDetails,
  PaymentDetails,
  DueDateCalculator,
  WeekByWeek,
  ThankYou,
  UnifiedReceipt,
  Shop,
  Faq,
  About,
  BumpFund,
  LoyaltyProgram,
  Contact,
  Partnerships,
  SignIn,
  ForgotPassword,
  ResetPassword,
  BreastPump,
  Careers,
  TermsOfService,
  PrivacyPolicy,
  SecurityDisclosure,
  ElectronicRecordsAndSignatureDisclosure,
  CorpGifting,
  Press,
  ErrorPage,
  Page404,
  Page403,
  Product,
  Review,
  SelectSubscription,
  GiftPage,
  Checkout,
  AdminPortalEntry,
  ShopRedirect,
  BlogRedirect,
  Blog,
  BreastPumpBrowse,
  BreastPumpPostPurchase,
  BreastPumpThankYou,
  CorporatePortal,
  CorporateWSP,
  CorporateVerification,
  PrenatalVitamins,
  CustomizeSubscription,
  CustomizeSubscriptionLandingPage,
  ViewRegistry,
  FindRegistry,
  ManageRegistry,
  CreateRegistry,
  Covid19,
  PatientGrievance,
  PatientRights,
  PrivacyNotice,
  Warranty,
  AssignmentOfBenefits,
  MyOrder,
  EditPayment,
  Giveaway,
  ReferAFriend,
  Extensions,
  CustomerReviews,
  Offers,
  GiveawayTerms,
  ImageEditor,
  BabyNames,
  StartMembership,
  WelcomeFlow,
  UnifiedCheckout,
};
